export default ({ title, benefitsIcons }) => ({
  title,
  benefitsIcons: benefitsIcons.map(({ icon, text }) => ({
    type: icon,
    label: text,
  })),
});
